<!-- The routed views render in the <router-outlet>-->
<ion-router-outlet></ion-router-outlet>